module.exports = __webpack_public_path__ + "img/home5.42d5cb5a.jpg";